/* eslint-disable jira/filename-case */
export const RESOURCE_TYPE_PROJECT_CONTEXT = 'PROJECT_CONTEXT';
